export enum ZipReduxTypes {
  FETCH_CITY_STATE_BY_ZIP = "@@pincode/FETCH_CITY_STATE_BY_ZIP",
  FETCH_CITY_STATE_BY_ZIP_SUCCESS = "@@pincode/FETCH_CITY_STATE_BY_ZIP_SUCCESS",
  FETCH_CITY_STATE_BY_ZIP_ERROR = "@@pincode/FETCH_CITY_STATE_BY_ZIP_ERROR",
  RESET = "@@pincode/RESET_ZIP_LOOKUP"
}

export type ZipGeoValue = {
  id?: string;
  name: string;
  [key: string]: any;
};

export type ZipLookupData = {
  zip?: string;
  city?: ZipGeoValue;
  state?: ZipGeoValue;
};

export type ZipActionDispatch = {
  type: ZipReduxTypes.FETCH_CITY_STATE_BY_ZIP | ZipReduxTypes.RESET;
  payload: any;
};

export type ZipReducerDispatch = {
  type:
    | ZipReduxTypes.FETCH_CITY_STATE_BY_ZIP
    | ZipReduxTypes.FETCH_CITY_STATE_BY_ZIP_SUCCESS
    | ZipReduxTypes.FETCH_CITY_STATE_BY_ZIP_ERROR
    | ZipReduxTypes.RESET;
  payload: {
    data?: ZipLookupData;
    error?: any;
    zip?: string;
  };
};

export type ZipReduxState = {
  loading?: boolean;
  data?: ZipLookupData;
  error?: any;
  zip?: string;
};

export type FetchCityStateByZipRequest = {
  payload: string;
  type: string;
};
